<template>
  <v-container>
    <v-snackbar v-model="fout" top light elevation="0">
      <v-alert border="top" color="red" text type="error" prominent
        >Deze code is niet bekend. Hebt u de juiste code ingevoerd?</v-alert
      ></v-snackbar
    >
    <h1>Welkom bij Vinnie</h1>
    Vul hier de vier cijfers in die je ontvangen hebt. Klik daarna op Start of
    druk op Enter.
    <v-form>
      <v-text-field
        maxlength="4"
        outlined
        style="width: 100px; font-size: 20pt"
        autofocus
        v-model="authcode"
      ></v-text-field>
      <v-btn x-large color="primary" @click="start()">Start</v-btn>
    </v-form>
  </v-container>
</template>


<script>
export default {
  name: "WebVinnieStart",
  props: {},
  data() {
    return { fout: false, authcode: "" };
  },
  methods: {
    start: function () {
      this.$api
        .pControleerAuthCode({ AuthCode: this.authcode })
        .then((response) => {
          if (response.data[0].Success) {
            this.fout = false;
            this.$router.push({
              name: "vragenlijstweb",
              params: { sessie: this.authcode },
              query: { e: "1" },
            });
          } else {
            this.fout = true;
          }
        });
    },
  },
  created: function () {},
};
</script>
